import * as Sentry from '@sentry/browser'

import {
  YLOPO_SIMILAR_HOMES,
  YLOPO_EQUITY_SMART_SEARCH
} from 'src/constants/ylopo'

export const selectYlopoSimilarHomes = state =>
  state.ylopo.listings[YLOPO_SIMILAR_HOMES] || null

export const selectYlopoEquitySmartSearch = state =>
  state.ylopo.listings[YLOPO_EQUITY_SMART_SEARCH] || null

export const selectYlopoUrl = state => state.ylopo.ylopoUrl

// remount is a function loaded via the ylopo widget, this is a way to see if it is present on the window.YLOPO_WIDGET object thus loaded properly
export const selectYlopoLoaded = () => {
  if (typeof window.YLOPO_WIDGETS.remount === 'function') {
    return true
  }
  Sentry.captureMessage('Ylopo is down')
  return false
}
